import type { Meta, StoryObj } from "@storybook/react";

import type { AvatarProps } from "@/ui/core";
import { Avatar } from "@/ui/core";
import type { AvatarSize } from "@/ui/core/Avatar";
import { AvatarUserTypeValues } from "@/ui/core/Avatar";
import { joinTestIDs } from "@/utils/string.util";

const AvatarSizeValues: Record<AvatarSize, AvatarSize> = {
  md: "md",
  sm: "sm",
  xs: "xs",
  xxs: "xxs",
};

const StoryMeta: Meta<AvatarProps> = {
  title: "Core/Avatar",
  component: Avatar,
  argTypes: {
    size: {
      control: "select",
      options: Object.values(AvatarSizeValues),
    },
    testID: { control: "text" },
    userName: { control: "text" },
    userType: {
      control: "select",
      options: Object.values(AvatarUserTypeValues),
    },
  },
  args: {
    size: AvatarSizeValues.sm,
    testID: joinTestIDs("olive", "lee"),
    userName: "Olive Lee",
    userType: AvatarUserTypeValues.provider,
  },
};

type Story = StoryObj<AvatarProps>;

const WithInitials: Story = {};

const WithImage: Story = {
  args: {
    imageUrl: "https://i.pravatar.cc/300",
  },
};

export { WithImage, WithInitials };
export default StoryMeta;
